import React from 'react';
import { REASON_CODES, REASON_LABELS } from '../utils/aiFeedback';

// Persistent "why dismiss?" bar for one suggestion (replaces the old 6-second
// toast chips). Nothing is dismissed until a reason is picked or Skip is
// clicked; Keep backs out and leaves the suggestion pending.
//
// Props: priceLabel ("$140" / "hold"), onPick(reasonCode), onSkip(), onCancel()
function DismissReasonBar({ priceLabel, onPick, onSkip, onCancel }) {
  return (
    <div className="dismiss-reason-bar" role="group" aria-label="Why dismiss this suggestion?">
      <span className="dismiss-reason-label">Dismiss {priceLabel} — why?</span>
      {REASON_CODES.map(code => (
        <button key={code} type="button" className="toast-reason-chip" onClick={() => onPick(code)}>
          {REASON_LABELS[code]}
        </button>
      ))}
      <button type="button" className="btn-link" onClick={onSkip} title="Dismiss without a reason">Skip</button>
      <button type="button" className="btn-link" onClick={onCancel} title="Don't dismiss — keep the suggestion">Keep</button>
    </div>
  );
}

export default DismissReasonBar;
